import { React, useState, useEffect } from 'react'
import { Box, Typography, Skeleton } from '@mui/material'
import LeaveBalanceCardList, {
  LeaveBalanceCardReplacement,
} from '../../myRequest/components/leaveBalanceCardList'

const BalanceList = ({ list, selectedList, handleSelectLeave }) => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)
  }, [])

  let array = new Array(3).fill('i')

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ py: 2.5, px: 3.25 }}>
        <Typography variant="subtitle1" color="dark-text.main">
          My leave balance
        </Typography>
        <Typography variant="body2" color="light-gray-text.main">
          Your leave balance for the current year
        </Typography>
      </Box>
      <Box sx={{ flex: 1 }}>
        {Object.keys(list).length !== 0 && list.constructor === Object && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {/* For Leave with entitlement */}
            {isLoading ? (
              array.map((arr, index) => (
                <Box key={index} width={'100%'} sx={{ display: 'flex' }}>
                  <Box width={3 / 4}>
                    <Skeleton height={40} />
                  </Box>
                  <Box width={1 / 4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Skeleton width={'80%'} height={40} />
                  </Box>
                </Box>
              ))
            ) : list.with_entitlement?.length ? (
              <>
                <Typography sx={{ mb: 1 }} variant="body2" color="light-gray-text-2.main">
                  Leave with entitlement
                </Typography>
                {list.with_entitlement?.map((item, index) => (
                  <LeaveBalanceCardList
                    key={item.id}
                    item={item}
                    inDrawer={true}
                    isSelected={selectedList.id === item.id && true}
                    selectLeave={handleSelectLeave}
                  />
                ))}
              </>
            ) : null}

            {/* For Leave without entitlement */}
            {isLoading ? (
              array.map((arr, index) => (
                <Box key={index} width={'100%'} sx={{ display: 'flex' }}>
                  <Box width={3 / 4}>
                    <Skeleton height={40} />
                  </Box>
                  <Box width={1 / 4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Skeleton width={'80%'} height={40} />
                  </Box>
                </Box>
              ))
            ) : list.without_entitlement?.length ? (
              <>
                <Typography sx={{ mb: 1 }} variant="body2" color="light-gray-text-2.main">
                  Leave without entitlement
                </Typography>
                {list.without_entitlement?.map((item, index) => (
                  <LeaveBalanceCardList
                    key={item.id}
                    item={item}
                    inDrawer={true}
                    isSelected={selectedList.id === item.id && true}
                    selectLeave={handleSelectLeave}
                  />
                ))}
              </>
            ) : null}

            {/* For Replacement Credit */}
            {isLoading ? (
              <Box width={'100%'} sx={{ display: 'flex' }}>
                <Box width={1 / 2}>
                  <Skeleton height={40} width={'100%'} />
                </Box>
                <Box
                  sx={{
                    width: 1 / 2,
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Skeleton height={40} width={'100%'} />
                </Box>
              </Box>
            ) : list.leave_credit.length ? (
              <>
                <Typography sx={{ mb: 1 }} variant="body2" color="light-gray-text-2.main">
                  Other
                </Typography>
                <LeaveBalanceCardReplacement
                  item={list.leave_credit[0]}
                  inDrawer={true}
                  selectLeave={handleSelectLeave}
                  isSelected={selectedList.id === list.leave_credit[0].id && true}
                />
              </>
            ) : null}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default BalanceList
